module.exports = __webpack_public_path__ + "media/images/lb/611-ebf6042c9e6e1d5846b3a288c2269796.svg";